import { P2GBox } from '@parcel2go/core-ui';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { IsDispatched } from '../../../lib/helpers/IsDispatched';
import { IsPackaged } from '../../../lib/helpers/IsPackaged';
import { ItemActionType } from '../../smartsend/item/SetMarketplaceAction';
import { PickingListSheetRow } from './PickingListSheetRow';
import { PickingListSheetRowMobile } from './PickingListSheetRowMobile';

interface props {
  items: SmartSendItemApiModel[];
  action: (action: ItemActionType, id: string) => void;
  working: boolean;
}

export function PickingListSheet(props: props) {
  const isXs = useP2GMediaQueryOnly('xs');

  if (isXs) {
    return props.items.map((x, i) => (
      <P2GBox key={x.Id}>
        {i > 0 && <P2GBox backgroundColour="#f1f1f1" p={1} />}
        <P2GBox bordered>
          <PickingListSheetRowMobile item={x} action={props.action} working={props.working} />
        </P2GBox>
      </P2GBox>
    ));
  }

  return (
    <table width={'100%'}>
      <tbody>
        {props.items.map((x) => (
          <PickingListSheetRow
            key={x.Id}
            item={x}
            action={props.action}
            dispatched={IsDispatched(x)}
            packaged={IsPackaged(x)}
            working={props.working}
          />
        ))}
      </tbody>
    </table>
  );
}
